// BFF: ○ gap — legacy formSubmission endpoints. The forms tab has no bff/crm module.
export { default } from './PatientDetailForms'
export { default as FormSubmissionRelatedView } from './FormSubmissionRelatedView'
export { getFormSubmissionStatus } from './utils'
